<template>
<div>
    <h1>Artists ({{ artistsCount }})</h1>             

    <div class="md-form mt-0 row">
        <input class="form-control form-control-sm ml-3 w-25" type="text" placeholder="Search" aria-label="Search" v-model="keywords">
        <button class="btn btn-primary" type="submit" v-on:click="search">Search</button>        
    </div>
    <br/>
    <div class="overflow-auto">
        <b-pagination
            v-model="currentPage"
            :total-rows="artistsCount"
            :per-page="artistByPage"
            :limit="10"
            @change="clickCallback">
        </b-pagination>
    </div>        
    <div v-bind:artists="artists">
        <table class="table">
            <tr>
                <th class="col-sm-9" @click="sort('name')">Name</th>
                <th class="col-sm-3" @click="sort('updateDateTime')">Update time</th>
            </tr>
            <tr v-for="artist in artists" v-bind:key="artist.id">                
                <td><router-link :to="{ name: 'artist', params: { id: artist.id }}">{{ artist.name }}</router-link></td>
                <td>{{ artist.updateDateTime | formatDate }}</td>
            </tr>
        </table>
    </div>
</div>
</template>

<script>
    
    import ApiClient from '@/tools/apiClient.js';

    let api = new ApiClient();

    export default {
        name: 'artists',            
        data: function () {
            return {
                artists: [],
                artistsCount: 0,                
                pageCount: 1,   
                artistByPage: 50,
                currentPage: 1,
                keywords: '',
                orderByField: "name",
                orderBy: "ascending"
            }
        },

        created: async function () {
            this.artistsCount = await api.getArtistsCountAsync();
            this.pageCount = this.artistsCount / this.artistByPage;
            this.keywords = '';
            
            this.artists = await api.getArtistsAsync(this.keywords, this.orderByField, this.orderBy, 0, this.artistByPage);
        },

        methods: {
            clickCallback: async function(page) {           
                this.currentPage = page;
                var offset = (page - 1) * this.artistByPage;              
                
                this.artists = await api.getArtistsAsync(this.keywords, this.orderByField, this.orderBy, offset, this.artistByPage);
            },

            search: async function() {
                var offset = 0;
                this.currentPage = 1;
                                                    
                this.artists = await api.getArtistsAsync(this.keywords, this.orderByField, this.orderBy, offset, this.artistByPage);
                
                if(this.keywords == '')
                    this.artistsCount = await api.getArtistsCountAsync();
                else
                    this.artistsCount = this.artists.length;

                this.currentPage = 1;                
                this.pageCount = this.artistsCount / this.artistByPage;                
            },

            sort: async function(field) {                
                if(field === this.orderByField) {
                    this.orderBy = this.orderBy === 'ascending' ? 'descending' : 'ascending';
                }

                this.orderByField = field;

                await this.search();
            }
        }
    }
</script>
